"use strict";
/**
 * Created by Ning Jiang on 4/20/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helper = void 0;
const GameConfig_1 = require("../gameconfig/GameConfig");
const Reels_1 = require("../reel/reelarea/Reels");
const UserAgent_1 = require("../useragent/UserAgent");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
class Helper {
    static getReelSet(name, index) {
        if (GameConfig_1.GameConfig.instance.REEL_SETS[name] && GameConfig_1.GameConfig.instance.REEL_SETS[name].length > 0) {
            const reelSet = GameConfig_1.GameConfig.instance.REEL_SETS[name][index];
            if (reelSet.length < 4) {
                Logger_1.Logger.logDev(`Helper.getReelSet() name = ${name}, index = ${index}, the reelset is too short that might break ReelController.randomizeReelSetPosition().`);
            }
            return reelSet;
        }
        debugger;
        throw new Error(`Error: Helper.getReelSet(): Reel ${name} does not contain any symbol!`);
    }
    static getSymbolPositions(reelId, symId, realSymbolPosition = false, device) {
        if (!device) {
            device = UserAgent_1.UserAgent.deviceName;
        }
        const reelAreaPositions = [GameConfig_1.GameConfig.instance.REEL_AREA_POS_X, GameConfig_1.GameConfig.instance.REEL_AREA_POS_Y];
        const symbolPositionsOnReelArea = Helper.getSymbolPositionsOnReelArea(reelId, symId, realSymbolPosition, device);
        return [reelAreaPositions[0] + symbolPositionsOnReelArea[0], reelAreaPositions[1] + symbolPositionsOnReelArea[1]];
    }
    static getSymbolPositionsOnReelArea(reelId, symId, realSymbolPosition = false, device) {
        var _a;
        if (!device) {
            device = UserAgent_1.UserAgent.deviceName;
        }
        const reelPositions = GameConfig_1.GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        if (realSymbolPosition) {
            try {
                const symbol = Reels_1.Reels.getSymbol(reelId, symId, false);
                if (symbol) {
                    return [reelPositions[0] + symbol.x, reelPositions[1] + symbol.y];
                }
            }
            catch (e) {
                // move to the next step.
            }
        }
        const symbolStep = ((_a = Reels_1.Reels.getReel(reelId)) === null || _a === void 0 ? void 0 : _a.symStep) ? Reels_1.Reels.getReel(reelId).symStep : GameConfig_1.GameConfig.instance.SYMBOL_HEIGHT + GameConfig_1.GameConfig.instance.SYMBOL_BOTTOM_PADDING;
        return [reelPositions[0], reelPositions[1] + symbolStep * symId + GameConfig_1.GameConfig.instance.SYMBOL_HEIGHT / 2];
    }
    //
    // public static getSymbolPositionAsPoint(reelIndex:number, symbolIndex:number, device?:string):PIXI.Point{
    //     const pos:number[] = Helper.getSymbolPositions(reelIndex, symbolIndex, device);
    //     return new PIXI.Point(pos[0], pos[1]);
    // }
    // /**
    //  * Creates a render texture copy of a container.
    //  *
    //  * Note on padding:
    //  * Sufficient padding for blur is: blurAmount x 2.
    //  * The final width of the texture will be original width + padding * 2 (one padding for each side)
    //  *
    //  * So to compensate placement for the final texture you can use: yourSprite.x += paddingX.
    //  *
    //  * @param originalContainer Container to create the texture from
    //  * @param paddingX Padding to accommodate for filter effects and such.
    //  * @param paddingY Padding to accommodate for filter effects and such.
    //  * @returns {PIXI.RenderTexture} The rendered texture.
    //  */
    // public static createRenderedTextureFromContainer(originalContainer:PIXI.Container, resolution:number,
    // paddingX:number = 0, paddingY:number = 0):PIXI.Texture{ const renderTexture:PIXI.RenderTexture =
    // PIXI.RenderTexture.create((originalContainer.width + paddingX * 2), (originalContainer.height + paddingY * 2),
    // PIXI.SCALE_MODES.DEFAULT, resolution); originalContainer.position.x += paddingX; originalContainer.position.y +=
    // paddingY; StageManager.renderer.render(originalContainer, renderTexture); originalContainer.position.x -=
    // paddingX; originalContainer.position.y -= paddingY; return renderTexture; }  /** * Creates a blurred texture
    // from a container. * @param container Container to create the texture from * @param blurX Blur amount X * @param
    // blurY Blur amount Y * @param outputScale Change scale of the container before blur is applied, resulting texture
    // will also be scaled. *     Scale is calculated: current scale * blurredOutputScale. * @param padding Should
    // padding be added to the rendered texture to prevent blur clipping. (If you do, you need to *     compensate
    // placement to accommodate for this change in size: yourContainer.x += blurX * 2, yourContainer += *     blurY*2);
    // * @returns {PIXI.Texture} A rendered blurred texture */ public static
    // createBlurredTextureFromContainer(container:PIXI.Container, blurX:number, blurY:number, outputScale:number,
    // padding:boolean = false, resolution:number):PIXI.Texture{ let outputTexture:PIXI.Texture; const
    // sourceScale:PIXI.Point = container.scale ? new PIXI.Point(container.scale.x, container.scale.y) : new
    // PIXI.Point(1, 1); container.scale.set(sourceScale.x * outputScale, sourceScale.y * outputScale);
    // if(StageManager.isWebGLSupported == true && DeviceInfo.forceCanvas() == false){ const
    // blur:PIXI.filters.BlurFilter = new PIXI.filters.BlurFilter(); blur.blurX = blurX; blur.blurY = blurY;
    // container.filters = [blur];  const paddingX = padding ? blurX * 2 : 0; const paddingY = padding ? blurY * 2 : 0;
    //  outputTexture = Helper.createRenderedTextureFromContainer(container, resolution, paddingX, paddingY);  //Reset
    // filters container.filters = [];  }else{ outputTexture = CanvasFilters.createBlurredTextureFromContainer(container, Math.ceil(Math.max(blurX, blurY)), resolution); }  //Reset original container container.scale = new PIXI.Point(sourceScale.x, sourceScale.y);  return outputTexture; }  /** * Creates a rendered blurred texture from a texture. * @param texture The texture that is going to be rendered with blur. * @param blurX Blur amount X * @param blurY Blur amount Y * @param outputScale Change scale of the container before blur is applied, resulting texture will also be scaled. *     Scale is calculated: current scale * blurredOutputScale. * @param padding Should padding be added to the rendered texture to prevent blur clipping. (If you do, you need to *     compensate placement to accommodate for this change in size: yourContainer.x += blurX * 2, yourContainer += *     blurY*2); * @returns {PIXI.Texture} A rendered blurred texture */ public static createBlurredTextureFromTexture(texture:PIXI.Texture, blurX:number, blurY:number, outputScale:number = 1, padding?:boolean):PIXI.Texture{ let tempSprite:PIXI.Sprite = new PIXI.Sprite(texture); let output:PIXI.Texture = Helper.createBlurredTextureFromContainer(tempSprite, blurX, blurY, outputScale, padding, tempSprite.texture.baseTexture.resolution); tempSprite = null; return output; }  static toDeviceCoord(value:number):number{ return value * SlotGameConfig.getConfig(SlotGameConfig.KEY_DEVICE_SCALE); }
    //TODO - Look over this thing. Canvas not supported anymore.
    /*    /!**
         * Creates a Texture using the Canvas renderer. Useful to get anti-aliasing on a WebGL rendered Graphics object.
         * @param container The display object you want to render with the canvas renderer.
         * @param resolution The resolution of the rendered Texture
         * @returns {PIXI.Texture} The rendered Texture
         *!/
        public static generateCanvasTexture(container:PIXI.Container, resolution:number):PIXI.Texture {
            let canvasTexture:PIXI.Texture;
            let renderTexture:PIXI.RenderTexture | null;
            const bounds:PIXI.Rectangle = container.getLocalBounds();
            container.x = -bounds.x;
            container.y = -bounds.y;

            // Changed PIXI.SCALE_MODES.DEFAULT to PIXI.SCALE_MODES.LINEAR when upgrading ts 2.0.
            renderTexture = PIXI.RenderTexture.create(bounds.width, bounds.height, PIXI.SCALE_MODES.LINEAR, resolution);

            StageManager.canvasRenderer.render(container, renderTexture, false);

            canvasTexture = PIXI.Texture.fromCanvas(<HTMLCanvasElement>renderTexture.baseTexture.source, PIXI.SCALE_MODES.LINEAR);
            canvasTexture.baseTexture.resolution = resolution;
            canvasTexture.baseTexture.update();

            renderTexture = null;

            return canvasTexture;
        }*/
    static toDeviceScale(value, mobileScale, round = true) {
        if (UserAgent_1.UserAgent.isMobile) {
            value *= mobileScale;
        }
        return round ? Math.round(value) : value;
    }
    static shrinkTextWidth(text, textContainer, maxWidth) {
        while (textContainer.width > maxWidth) {
            if (typeof textContainer.style.fontSize === "string") {
                if (textContainer.style.fontSize.indexOf("em") > -1) {
                    debugger;
                    throw new Error("Helper.shrinkTextWidth(), I am lazy so I don't want to parse em, please use number or px.");
                }
                textContainer.style.fontSize = parseInt(textContainer.style.fontSize);
            }
            textContainer.style.fontSize--;
            if (textContainer.style.fontSize <= 10) {
                textContainer.style.fontSize = 10;
                return;
            }
        }
    }
    static fitItemInRectangle(object, rectangle, maxScale) {
        const scaleX = rectangle.width / (object.width / object.scale.x);
        const scaleY = rectangle.height / (object.height / object.scale.y);
        let endScale = Math.min(scaleX, scaleY);
        if (maxScale != null) {
            endScale = Math.min(endScale, maxScale);
        }
        object.scale.set(endScale, endScale);
        if (object instanceof PIXI.Sprite) {
            object.x = rectangle.x + rectangle.width / 2 + object.width * (object.anchor.x - 0.5);
            object.y = rectangle.y + rectangle.height / 2 + object.height * (object.anchor.y - 0.5);
        }
        else {
            object.x = rectangle.x + rectangle.width / 2; // use defautl ancher (0.5, 0.5)
            object.y = rectangle.y + rectangle.height / 2;
        }
    }
    /**
     * input the global position from api/html container, output position on layer.
     * example, a mouse event gives a global position, use the output position to do something on the layer.
     * You can also use the api resize data as input and get the corresponding position on the layer.
     **/
    static globalPositionToLayerPosition(globalPosition, layer) {
        return [Math.floor((globalPosition[0] - layer.x) / layer.scale.x), Math.floor((globalPosition[1] - layer.y) / layer.scale.y)];
    }
    /**
     * Kill the Timeline and return it in it's current state or replace it with a new one.
     * @param tl TimelineMax.
     * @param tlR Define this if you want to return with a newly defined timeline.
     * @param forceEnd boolean, use this if you want to jump to end of the timeline before killing it.
     * @returns {TimelineMax}
    */
    static timeLineKiller(tl, tlR, forceEnd = false) {
        if (!tl)
            return tlR ? tlR : tl;
        if (forceEnd)
            tl.totalProgress(1);
        tl.pause();
        tl.kill();
        tl.clear();
        return tlR ? tlR : tl;
    }
    /**
     * Kill the Timeline and return a null when done.
     * @param tl Timeline, TimelineLite, TimelineMax or null.
     * @param forceEnd boolean, use this if you want to jump to end of the timeline before killing it.
     * @returns {null}
    */
    static timeLineNuller(tl, forceEnd = false) {
        if (!tl)
            return null;
        let tLiteMax = tl;
        if (forceEnd)
            tLiteMax.totalProgress(1);
        if (tLiteMax) {
            tLiteMax.pause();
            tLiteMax.kill();
            tLiteMax.clear();
        }
        else {
            tl.pause();
            tl.kill();
        }
        return null;
    }
    /**
     * QuickCreation of a new PIXI.Sprite.
     * @param texture PIXI.Texture.
     * @returns {null}
    */
    static createSprite(texture) {
        let sp = new PIXI.Sprite(texture);
        sp.anchor.set(0.5, 0.5);
        sp.alpha = 0;
        return sp;
    }
    /**
    * A PollyFill, Internet Explorer does not support Object.Assign()
    * @param from Object to copy from.
    * @param args T. Define at RunTime on what type of Object we are are going to copy to.
    * @returns {T} <T> Any.
   */
    static assignObj(from, args) {
        let to = Object(from);
        for (var index = 1; index < arguments.length; index++) {
            let nextSource = arguments[index];
            if (nextSource !== null && nextSource !== undefined) {
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    }
    /**  Use this method to catch the position from the tranformWorld between two objects in two different containers/layers.
    *    This is heavily used in PunkRocker as part of an ReelMap system.
    *    It made it possible to let the JumpingWilds chase the MysteryExpandPositions during animations.
    */
    static copyLocalPosition(objToSet, objToMimic) {
        return objToSet.parent.toLocal(objToSet.parent.position, objToMimic);
    }
}
exports.Helper = Helper;
//# sourceMappingURL=Helper.js.map